import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../services/language.service';

@Component({
    selector: 'app-services-bd',
    templateUrl: 'services-bd.component.html',
    styleUrls: ['../pages.scss', 'services-bd.component.scss'],
})

export class ServicesBDComponent {
    activeLanguage = 'german';
    constructor(private ls: LanguageService) {
      ls.getLanguage().subscribe(val => this.activeLanguage = val);
    }
    content = {
        german: `
        <div class="row">
          <div class="col image">
            <img src="/assets/technology-world.jpg">
          </div>
        </div>
        <div class="row margin-below">
          <div class="col">
              <h1 class="header">Geschäftsfeldentwicklung</h1>
          </div>
        </div>
    <div class="row">
         <div class="text-content col-12">
                <p class="start-indent">
                    <span class="highlight">Technologie Consulting Wolke</span> unterstützt Kunden speziell in technologisch
                    anspruchsvollen Branchen in der nachhaltigen Entwicklung ihrer Geschäftsfelder. Wir bringen langjährige
                    Erfahrung aus verschiedenen Bereichen ein z. B. für:
                </p>
                <ul>
                    <li>Die strategische Produktentwicklung: identifizieren und bewerten neuer
                    Geschäftsfelder auf Basis vorhandener Produkte und Kompetenzen</li>
                    <li>Erstellen von Markt- und Potenzialanalysen für neue Produktideen (SWOT)</li>
                    <li>Die Entwicklung neuer Geschäftsideen in profitable Produktkonzepte: Erstellen und bewerten
                     von kritischen Erfolgsfaktoren und Risiken, Wettbewerbsanalysen, Marktpotenziale</li>
                    <li>Die Einführung und Begleitung strukturierter Entwicklungsprozesse</li>
                    <li>Die Verkürzung von Entwicklungszeiten bei gleichbleibender Qualität</li>
                    <li>Die Leitung von (Teil-)Projekten für die Neu- und Weiterentwicklung
                     des Produktportfolios (z.B Standardisierung)</li>
                    <li>Die Sicherstellung der Produktqualität und Zuverlässigkeit in allen Phasen der Produktlebenszyklus</li>
                </ul>
                <p><em>Fragen Sie nach konkreten Projektbeispielen und Referenzen!</em></p>
            </div>
            </div>`,
      english: `
      <div class="row">
        <div class="col image">
          <img src="/assets/technology-world.jpg">
        </div>
      </div>
      <div class="row margin-below">
          <div class="col">
              <h1 class="header">Business Development</h1>
          </div>
      </div>
  <div class="row">
       <div class="text-content col-12">
              <p class="start-indent">
                  <span class="highlight">Technologie Consulting Wolke</span> provides compentent advisory
                  in both sustainable growth of existing fields of business as well as identifying
                  and entering new market opportunities  in particular in advanced technology segments like
                  semiconductors, automotive, and precision machinery. We provide many years of experience
                  from marketing, planning and development from small size enterprise to global corporations:
              </p>
              <ul>
                  <li>Strategic product development: Identify and assess new business potentials based on
                  existing products and competencies</li>
                  <li>SWOT Analysis: strengths, weaknesses, opportunities and threads for new business ideas in
                  all stages of development</li>
                  <li>Business development transfer: Convert concepts into lucrative products by analysis of
                  critical success factors, competititve analysis, market assessability and entry strategies.</li>
                  <li>Introduction and coaching of business processes for structures new product development.</li>
                  <li>Efficiency boost in R&D turnaorund cycles without quality loss</li>
                  <li>Project Management in R&D on specific or "lost" tasks</li>
                  <li>Product quality assurance, technical risk management and reliability throughout the entire
                  product life cycle.</li>
              </ul>
              <p><em>Feel free to ask for project examples and references!</em></p>
          </div>
          </div>
          `,
    };

}



// WEBPACK FOOTER //
// ./src/app/components/services-bd/services-bd.component.ts